import React from 'react';
import { QueryString, isPlainObject } from '@grandvisionhq/utils';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function OneTrustCookieConsent(_a) {
    var locale = _a.locale, src = _a.src, domain = _a.domain;
    if (!src || !domain) {
        console.error("Unable to initiate OneTrust with {" + JSON.stringify({ src: src, domain: domain }) + "}");
        return null;
    }
    var _b = __read(locale.split('-'), 1), language = _b[0];
    return (React.createElement(React.Fragment, null,
        React.createElement("script", { type: "text/javascript", charSet: "UTF-8", crossOrigin: "anonymous", "data-language": language, "data-domain-script": domain, src: src }),
        React.createElement("script", { type: "text/javascript" }, "function OptanonWrapper() ")));
}

var MAX_TRY = 30;
var timer;
var handlers = [];
var tryCount = 0;
function handleConsentChange() {
    for (var i = 0; i < handlers.length; i++) {
        try {
            handlers[i]();
        }
        catch (_a) { }
    }
}
function onConsentChange(handler) {
    clearInterval(timer);
    if (!handlers.includes(handler)) {
        handlers.push(handler);
    }
    if (window.Optanon) {
        window.Optanon.OnConsentChanged(handleConsentChange);
        return;
    }
    timer = setInterval(function () {
        if (window.Optanon) {
            clearInterval(timer);
            window.Optanon.OnConsentChanged(handleConsentChange);
        }
        else {
            ++tryCount;
            if (tryCount > MAX_TRY) {
                clearInterval(timer);
            }
        }
    }, 1000);
}

function BypassProvider() {
    return new Set(['required', 'analytics', 'functional']);
}

// empty consent
var EmptyConsent = new Set();

var OneTrustConsentMap = {
    C0001: 'required',
    C0002: 'analytics',
    C0003: 'functional',
    C0004: 'marketing',
    C0005: 'social',
};
var isOneTrustCookie = function (data) {
    return isPlainObject(data) && 'groups' in data;
};
function getConsentResult(cookies) {
    var consentRawData = (cookies === null || cookies === void 0 ? void 0 : cookies.OptanonConsent) || '';
    if (!consentRawData) {
        return EmptyConsent;
    }
    var parsedValues = QueryString.parse(consentRawData);
    if (!isOneTrustCookie(parsedValues)) {
        return EmptyConsent;
    }
    return new Set(parsedValues.groups
        .split(',') // => [ 'C0001:1', 'C0002:0', ... ]
        .map(function (pair) { return pair.split(':'); }) // => [ ['C0001', '1'], ['C0002', '0'], ... ]
        .filter(function (_a) {
        var _b = __read(_a, 2), value = _b[1];
        return +value;
    }) // => [ ['C0001', '1'], ... ]
        .map(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return OneTrustConsentMap[key];
    }) // => [ 'required', ... ]
    );
}
var OneTrustProvider = function (cookies) {
    return getConsentResult(cookies);
};

export { BypassProvider, EmptyConsent, OneTrustCookieConsent, OneTrustProvider, onConsentChange };
//# sourceMappingURL=index.js.map
